module.exports = __webpack_public_path__ + "b08203950f86f5b8fed46277f9ecfbe4.svg";